import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

export const visibleHiddenDesktopDownCssRaw = css.raw({
  smallDesktopDown: { visibility: 'hidden', position: 'absolute', zIndex: -1, touchAction: 'none' },
});

export const menuListCssRaw = css.raw({
  w: 'max-content',
  minW: 120,
  maxW: 210,
  '& > li + li': { mt: 4 },
});

export const menuItemCssRaw = stack.raw({
  textStyle: 'Text/M/Strong',
  textAlign: 'left',
  color: 'content.default.level-5',
  py: 8,
  gap: 4,
  _hover: { color: 'content.accent.info' },
});

export const menuSelectedCssRaw = css.raw({
  color: 'content.default.level-5',
});

export const tradFiGradientCssRaw = css.raw({
  display: 'inline-block',
  backgroundImage: 'linear-gradient(90deg, #c8ff00, #0a84ff, #c8ff00)',
  backgroundSize: '200% 100%',
  backgroundClip: 'text',
  color: 'transparent',
  WebkitTextFillColor: 'transparent',
  animation: 'tradFiGradientSweep 8s ease-in-out infinite',
  _hover: { color: 'transparent', WebkitTextFillColor: 'transparent' },
  _motionReduce: { animation: 'none' },
});
